export default {
      id: "plan_interactif-usage",
      viewBox: "0 0 80 60",
      url: "../dist/images/" + "sprite.svg#plan_interactif-usage",
      toString: function () {
        return this.url;
      }
    }